import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { Observable, of as observableOf } from 'rxjs';
import { filter, map, switchMap, switchMapTo } from 'rxjs/operators';

import { authState, isAuthenticated } from '../../reducers/auth/auth-service.selectors';

@Injectable()
export class AccountClosedGuard {
  private store = inject<Store<AppState>>(Store);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.retrieveAuthenticatedStatus().pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          this.redirectToDashboard();
          return observableOf(false);
        } else {
          return observableOf(true);
        }
      }),
    );
  }

  private retrieveAuthenticatedStatus() {
    return this.store.select(authState).pipe(
      map((state) => state.loading),
      filter((loading) => !loading),
      switchMapTo(this.store.select(isAuthenticated)),
    );
  }

  private redirectToDashboard() {
    this.router.navigate(['/']);
  }
}
